// extracted by mini-css-extract-plugin
export default {"icon":"_3rEnLlNY7dmge-Kz0uli3o"};